/**
 * Display helpers for System vs external (OMEGA) billing invoices.
 * Keep in sync with BillingInvoiceResource document_source / display_number.
 */

export function isExternalAccountingInvoice(invoice) {
  if (!invoice) return false;
  return invoice.document_source === 'external_accounting'
    || invoice.provider === 'external_accounting';
}

export function getInvoiceDisplayNumber(invoice, emptyValue = '—') {
  if (!invoice) return emptyValue;
  return invoice.display_number
    || invoice.external_invoice_number
    || invoice.public_number
    || emptyValue;
}

export function canDownloadInvoicePdf(invoice) {
  if (!invoice || isExternalAccountingInvoice(invoice)) {
    return false;
  }
  return Boolean(invoice.pdf_download_available || invoice.pdf_status === 'generated');
}
